<template>
    <ul class="pagination">
        <li v-if="!simplified && !isInFirstPage" class="page-item">
            <a @click="goToPage(1)" class= "p-2 page-link">
                <i class="fas fa-fast-backward"></i>
            </a>
        </li>
        <li v-for="(page, key) in pages" :key=key :class="'page-item ' + (page.isActive ? ' disabled active' : '')">
            <a @click="goToPage(page.name)" class= "p-2 page-link" v-text="page.name"></a>
        </li>
        <li v-if="!simplified && !isInLastPage" class="page-item">
            <a @click="goToPage(totalPages)" class= "p-2 page-link">
                <i class="fas fa-fast-forward"></i>
            </a>
        </li>
    </ul>
</template>

<script>
export default {
	name: "Pagination",
	props: {
        maxVisibleButtons: { type: Number, default: 5 },
        totalPages: { type: Number, required: true, default: 1 },
        currentPage: { type: Number, required: true, default: 1 },
        simplified: { type: Boolean, default: false },
    },
	computed: {
        startingPage() {
            const middleCounter = Math.floor(this.maxVisibleButtons / 2);

            if (this.totalPages < this.maxVisibleButtons || this.currentPage <= middleCounter) {
                return 1;
            } else if ((this.totalPages - middleCounter) < this.currentPage) {
                return this.totalPages - this.maxVisibleButtons + 1;
            }

            return this.currentPage - middleCounter;
        },
        pages() {
            const pages = [];
            const lastPage = Math.min(this.startingPage + this.maxVisibleButtons - 1, this.totalPages);

            for (let i = this.startingPage; i <= lastPage; i+= 1 ) {
                pages.push({
                    name: i,
                    isActive: i === this.currentPage
                });
            }

            return pages;
        },
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.totalPages;
        },
	},
	methods: {
        goToPage(page) {
            this.$emit('pageChanged', page);
        },
    },
};
</script>
<style lang="css" scoped>
    .page-item .page-link {
        border-radius: 4px !important;
    }
</style>
